"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgFolderBrowse(props) {
    return (React.createElement("svg", __assign({ xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 16 16' }, props),
        React.createElement("path", { d: 'M10.332,12H1a1.07539,1.07539,0,0,1-1-1V1A1.07539,1.07539,0,0,1,1,0H5A1.07539,1.07539,0,0,1,6,1V2h7a1.07539,1.07539,0,0,1,1,1V8.726L12.55176,7.27588a1.2877,1.2877,0,0,0-.918-.38233A1.30274,1.30274,0,0,0,10.332,8.19434Zm4.11674,1.09917,1.36385-.5529a.3.3,0,0,0,.09958-.49L11.84406,7.98209a.3.3,0,0,0-.51229.212V13.9175a.3.3,0,0,0,.41271.278l1.50178-.60886.98779,2.29443a.19659.19659,0,0,0,.2583.10285l.83038-.35754a.19655.19655,0,0,0,.10285-.25831Z' })));
}
exports.default = SvgFolderBrowse;
